const admission = [{
  path: 'admission/index',
  component: resolve => require(['../../../../components/pages/user/admission'], resolve)
}]

export default admission
